import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import RadioGroupContext from './RadioGroupContext';
import clsx from 'clsx';

/**
 * 
 * @param {object} params
 * @param {boolean} [params.disabled]
 * @param {function} [params.onChange]
 * @param {string} [params.name]
 * @param {string} [params.value]
 * @param {string} [params.className]
 */
function SMCRadioGroup({
    disabled,
    onChange,
    name,
    value,
    style,
    className,
    children
}) {
    const classes = useStyles();

    const radioGroupContextValue = {
        selectedValue: value,
        onChange,
        disabled,
        name
    };

    return (
        <RadioGroupContext.Provider value={radioGroupContextValue}>
            <div className={clsx(classes.root, className)} style={style}>
                {children}
            </div>
        </RadioGroupContext.Provider>
    );
}

const useStyles = makeStyles({
    root: {
        lineHeight: '14px'
    }
})

SMCRadioGroup.propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string,
    value: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    children: PropTypes.node
}

export default React.memo(SMCRadioGroup);